import React, {Component} from 'react';
import './App.css';
import Loadable from 'react-loadable';
import {BrowserRouter, HashRouter, Redirect, Route, Switch} from 'react-router-dom'
import LoadingComponent from "./Components/Loading";
import {availableLanguages, lStrings, setLanguage} from './Constants/Strings';
import ScrollToTop from "./Components/ScrollToTop";

const Main = Loadable({
    loader: () => import('./Components/Main'),
    loading: LoadingComponent
});
const Jobs = Loadable({
    loader: () => import('./Jobs/Jobs'),
    loading: LoadingComponent
});
const Service = Loadable({
    loader: () => import('./Service/Service'),
    loading: LoadingComponent
});
const News = Loadable({
    loader: () => import('./News/News'),
    loading: LoadingComponent
});
const NewsDetail = Loadable({
    loader: () => import('./News/NewsDetail'),
    loading: LoadingComponent
});
const Contact = Loadable({
    loader: () => import('./Contact/Contact'),
    loading: LoadingComponent
});

const Locales = ({routes}) => (
    <div>
        <Switch>
            {routes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />)}
            <Redirect from='*' to={'/ja/main'}/>
        </Switch>
    </div>
);

const routes = [
    {
        path: "/:locale",
        component: Locales,
        routes: [
            {
                path: "/:locale/main",
                component: Main,
                exact: false
            },
            {
                path: "/:locale/jobs",
                component: Jobs,
                exact: false
            },
            {
                path: "/:locale/news",
                component: News,
                exact: true
            },
            {
                path: "/:locale/news/:id",
                component: NewsDetail,
                exact: false
            },
            {
                path: "/:locale/service",
                component: Service,
                exact: false
            },
            {
                path: "/:locale/contact",
                component: Contact,
                exact: false
            }
        ]
    }
];


// wrap <Route> and use this everywhere instead, then when
// sub routes are added to any route it'll work
const RouteWithSubRoutes = route => {
    return <Route
        path={route.path}
        exact={route.exact}
        render={props => (
            // pass the sub-routes down to keep nesting
            <route.component {...props} routes={route.routes}/>
        )}
    />
};


class App extends Component {

    constructor() {
        super();

        let lang = lStrings.getInterfaceLanguage();
        if (window.navigator.userAgent && window.navigator.userAgent.toLowerCase().startsWith('prerender') >= 0) {
            lang = 'ja';
        }

        if (process.env.REACT_APP_HASH === 'true') {
            const langHash = /#\/([a-z]+)\//.exec(window.location.hash);
            if (langHash !== null) {
                lang = langHash[1];
            }
            if (lang && lang !== undefined && availableLanguages.indexOf(lang) >= 0) {

            } else {
                lang = 'ja';
            }
        } else {
            const hash = window.location.hash;
            if (window.location.pathname === '/' && hash && hash.startsWith('#/')) {
                window.location.assign(window.location.origin + hash.substring(1));
                return;
            }

            const langHash = /\/([a-z]+)\//.exec(window.location.pathname);
            if (langHash !== null) {
                lang = langHash[1];
            }
            if (lang && lang !== undefined && availableLanguages.indexOf(lang) >= 0) {

            } else {
                lang = 'ja';
            }
        }

        setLanguage(lang);
        this.state = {
            defaultLang: lang
        };
    }

    componentDidMount() {
    }

    render() {
        return <div id="app-main">
            <div/>
            {(() => {
                if (process.env.REACT_APP_HASH === 'true') {
                    return <HashRouter>
                        <ScrollToTop>
                            <div>
                                <section className="content">
                                    <Switch>
                                        {routes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />)}
                                        <Redirect from='*' to={'/' + this.state.defaultLang + '/main'}/>
                                    </Switch>
                                </section>
                            </div>
                        </ScrollToTop>
                    </HashRouter>
                } else {
                    return <BrowserRouter>
                        <ScrollToTop>
                            <div>
                                <section className="content">
                                    <Switch>
                                        {routes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />)}
                                        <Redirect from='*' to={'/' + this.state.defaultLang + '/main'}/>
                                    </Switch>
                                </section>
                            </div>
                        </ScrollToTop>
                    </BrowserRouter>
                }
            })()}
        </div>
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js